import { Component, Inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { WebpService } from 'lib/services/webp.service';
import { Location } from '@angular/common';
import { ProductSpecDialogComponent } from 'lib/components/product-spec-dialog/product-spec-dialog.component';
import { ExxComError } from 'lib/classes/exxcom-error.class';
import { MatDialog } from '@angular/material/dialog';

const scriptName = 'cms-partial-category-top-component-product-options.component';

@Component({
    selector: 'cms-partial-category-top-component-product-options',
    templateUrl: './product-options.component.html',
    styleUrls: ['./product-options.component.scss'],
    standalone: true,
    imports: [CommonModule, RouterModule],
})
export class ProductOptionsComponent extends CmsPartialComponentClass implements OnInit {
    @Input() productOptionsRow: any;
    getWebpImg: (src: string) => string;
    private xsBreakpointObserver: Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.XSmall);

    constructor(
        @Inject('environment') environment: any,
        breakpointObserver: BreakpointObserver,
        routerService: RouterService,
        webpService: WebpService,
        dialog: MatDialog,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                breakpointObserver,
                dialog,
                environment,
                routerService,
                location,
                categoryService,
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }

    openProductSpecDialog(products?: any, options?: any) {
        try {
            const productsSpecs = new Set(['Product']);
            const productsValues = [];
            const productsLinks = [];
            if (products) {
                products.map((product: any) => {
                    const productValue = [];
                    productValue.push(product.title);
                    product.specs_group.map((specs) => {
                        productsSpecs.add(specs.spec);
                        productValue.push(specs.value);
                    });
                    productsValues.push(productValue);
                    productsLinks.push(product.product_link && product.product_link.routerLink);
                });
            }
            const productDialogRef = this.dialog.open(ProductSpecDialogComponent, {
                data: options
                    ? { options: options }
                    : {
                          specs: productsSpecs,
                          values: productsValues,
                          links: productsLinks,
                      },
                maxWidth: '1000px',
                panelClass: 'dialog-mob-only-product-spec',
            });
            const smallDialogSubscription = this.xsBreakpointObserver.subscribe((size) => {
                if (size.matches) {
                    productDialogRef.updateSize('100vw', '100vh');
                } else {
                    productDialogRef.updateSize('auto', 'auto');
                }
            });
            productDialogRef.afterClosed().subscribe(() => smallDialogSubscription.unsubscribe());
        } catch (err) {
            console.error(...new ExxComError(636423, scriptName, err).stamp());
        }
    }

    ngOnInit() {}
}
